/**
 * Default clinic settings.
 *
 * Lives in its own module so the PUBLIC bundle can use it as an initial
 * render value without importing `settingsService.js`, which drags in the
 * full (admin) Firestore SDK for its write path.
 */
export const DEFAULT_SETTINGS = {
    address:          'м. Івано-Франківськ, вул. Красівського 1',
    addressEn:        "Ivano-Frankivsk, Krasivs'koho St, 1",
    phone:            '(096) 947-14-73',
    email:            'info@udent.com.ua',
    facebookUrl:      '',  // Set via Admin → Settings
    instagramUrl:     '',  // Set via Admin → Settings
    hoursWeekdays:    'Пн–Пт: 9:00–19:00',
    hoursWeekdaysEn:  'Mon–Fri: 9:00–19:00',
    hoursSaturday:    'Сб: 10:00–15:00',
    hoursSaturdayEn:  'Sat: 10:00–15:00',
    hoursSunday:      'Нд: Вихідний',
    hoursSundayEn:    'Sun: Closed',
    topBarHours:      'Пн–Пт: 9:00–19:00 | Сб: 10:00–15:00',
    topBarHoursEn:    'Mon–Fri: 9:00–19:00 | Sat: 10:00–15:00',
    mapQuery:         'м. Івано-Франківськ, вулиця Красівського, 1',
};

/** Get default settings (for fallback / reset). */
export function getDefaultSettings() {
    return { ...DEFAULT_SETTINGS };
}
